define('utils/callback', [
],  function () {
    'use strict';

    console.log('%cfile: callback.js', 'color: #C2ECFF');

    var callback = {},
        timer,
        alertCloseTime = 5000;

    callback.done = function(data){
        console.log('%ctrace: callback.done', 'color: #ccc', data);

        var type = data.type;
        var parameters = data.parameters || null;
        var code = data.code;
        var namespace = data.namespace || 'defaults';
        var text = data.text;

        if(!this[namespace] || !this[namespace][code]){
            console.warn('%cCallback -> done: undefined callback', 'color: #FF7000');
            return false;
        }

        this[namespace][code](type, text, parameters);

        return true;
    };

    callback['default'] = {
        'error': function(type, text, parameters){
            console.log('%ctrace: callback.default.error', 'color: #ccc');

            $('.js__feedback-alert').html('Заполните все поля').removeClass('success').addClass('error');
        },
        'success': function(type, text, parameters){
            console.log('%ctrace: callback.default.success', 'color: #ccc');
        },
        'title_empty': function(type, text, parameters){
            console.log('%ctrace: callback.default.title_empty', 'color: #ccc');
        },
        'content_empty': function(type, text, parameters){
            console.log('%ctrace: callback.default.content_empty', 'color: #ccc');

            var $form = parameters.$form;
            var $alert = $form.find('.js__feedback-alert');
            var $el = $form.find('[name="content"]');

            $alert.html('Заполните все поля').removeClass('success').addClass('error');

            if ($('html').is('.safari')) {
                return false;
            }

            $el.trigger('focus');
            $el.velocity('stop').velocity('callout.shake', {
                duration: 1000,
                delay: 0,
                stagger: 0,
                mobileHA: true,
                begin: function(){
                },
                complete: function(){

                }
            });
        },
        'name_empty': function(type, text, parameters) {
            console.log('%ctrace: callback.default.name_empty', 'color: #ccc');

            var $form = parameters.$form;
            var $alert = $form.find('.js__feedback-alert');
            var $el = $form.find('[name="name"]');

            if ($alert.is('.promo-action__alert')) {
                $alert.html('<i>Заполните все поля</i>').removeClass('success').addClass('error');
            } else {
                $alert.html('Заполните все поля').removeClass('success').addClass('error');
            }

            clearTimeout(timer);
            timer = setTimeout(function(){
                $alert.removeClass('error success');
            }, alertCloseTime);

            if ($('html').is('.safari')) {
                return false;
            }

            $el.trigger('focus');
            $el.velocity('stop').velocity('callout.shake', {
                duration: 1000,
                delay: 0,
                stagger: 0,
                mobileHA: true,
                begin: function(){
                },
                complete: function(){

                }
            });
        },
        'telormail_empty': function(type, text, parameters){
            console.log('%ctrace: callback.default.phone_empty', 'color: #ccc');

            var $form = parameters.$form;
            var $alert = $form.find('.js__feedback-alert');
            var $el = $form.find('[name="telormail"]');

            $alert.html('<i>Заполните все поля</i>').removeClass('success').addClass('error');

            clearTimeout(timer);
            timer = setTimeout(function(){
                $alert.removeClass('error success');
            }, alertCloseTime);

            if ($('html').is('.safari')) {
                return false;
            }

            $el.trigger('focus');
            $el.velocity('stop').velocity('callout.shake', {
                duration: 1000,
                delay: 0,
                stagger: 0,
                mobileHA: true,
                begin: function(){
                },
                complete: function(){

                }
            });
        },
        'telormail_not_valid': function(type, text, parameters){
            console.log('%ctrace: callback.default.phone_empty', 'color: #ccc');

            var $form = parameters.$form;
            var $alert = $form.find('.js__feedback-alert');
            var $el = $form.find('[name="telormail"]');

            $alert.html('<i>Укажите правильный телефон или почту<br/>(926 000-00-00 или name@mymail.ru)</i>').removeClass('success').addClass('error');

            clearTimeout(timer);
            timer = setTimeout(function(){
                $alert.removeClass('error success');
            }, alertCloseTime);

            if ($('html').is('.safari')) {
                return false;
            }

            $el.trigger('focus');
            $el.velocity('stop').velocity('callout.shake', {
                duration: 1000,
                delay: 0,
                stagger: 0,
                mobileHA: true,
                begin: function(){
                },
                complete: function(){

                }
            });
        },
        'email_empty': function(type, text, parameters){
            console.log('%ctrace: callback.default.email_empty', 'color: #ccc');

            var $form = parameters.$form;
            var $alert = $form.find('.js__feedback-alert');
            var $el = $form.find('[name="email"]');

            $alert.html('Заполните все поля').removeClass('success').addClass('error');

            clearTimeout(timer);
            timer = setTimeout(function(){
                $alert.removeClass('error success');
            }, alertCloseTime);

            if ($('html').is('.safari')) {
                return false;
            }

            $el.trigger('focus');
            $el.velocity('stop').velocity('callout.shake', {
                duration: 1000,
                delay: 0,
                stagger: 0,
                mobileHA: true,
                begin: function(){
                },
                complete: function(){

                }
            });
        },
        'email_not_valid': function(type, text, parameters){
            console.log('%ctrace: callback.default.email_not_valid', 'color: #ccc');

            var $form = parameters.$form;
            var $alert = $form.find('.js__feedback-alert');
            var $el = $form.find('[name="email"]');

            $alert.html('Укажите правильную почту').removeClass('success').addClass('error');

            clearTimeout(timer);
            timer = setTimeout(function(){
                $alert.removeClass('error success');
            }, alertCloseTime);

            if ($('html').is('.safari')) {
                return false;
            }

            $el.trigger('focus');
            $el.velocity('stop').velocity('callout.shake', {
                duration: 1000,
                delay: 0,
                stagger: 0,
                mobileHA: true,
                begin: function(){
                },
                complete: function(){

                }
            });
        },
        'phone_empty': function(type, text, parameters){
            console.log('%ctrace: callback.default.phone_empty', 'color: #ccc');

            var $form = parameters.$form;
            var $alert = $form.find('.js__feedback-alert');
            var $el = $form.find('[name="phone"]');

            $alert.html('Заполните все поля').removeClass('success').addClass('error');

            clearTimeout(timer);
            timer = setTimeout(function(){
                $alert.removeClass('error success');
            }, alertCloseTime);

            if ($('html').is('.safari')) {
                return false;
            }

            $el.trigger('focus');
            $el.velocity('stop').velocity('callout.shake', {
                duration: 1000,
                delay: 0,
                stagger: 0,
                mobileHA: true,
                begin: function(){
                },
                complete: function(){

                }
            });
        },
        'phone_not_valid': function(type, text, parameters){
            console.log('%ctrace: callback.default.phone_not_valid', 'color: #ccc');

            var $form = parameters.$form;
            var $alert = $form.find('.js__feedback-alert');
            var $el = $form.find('[name="phone"]');

            $alert.html('Укажите правильный телефон').removeClass('success').addClass('error');

            clearTimeout(timer);
            timer = setTimeout(function(){
                $alert.removeClass('error success');
            }, alertCloseTime);

            if ($('html').is('.safari')) {
                return false;
            }

            $el.trigger('focus');
            $el.velocity('stop').velocity('callout.shake', {
                duration: 1000,
                delay: 0,
                stagger: 0,
                mobileHA: true,
                begin: function(){
                },
                complete: function(){

                }
            });
        }
    };

    callback['add_coupon'] = {
        'add_coupon_sms_error': function(type, text, parameters){
            console.log('%ctrace: callback.default.phone_not_valid', 'color: #ccc');

            var $form = parameters.$form;
            var $alert = $form.find('.js__feedback-alert');
            var $el = $form.find('[name="telormail"]');

            $alert.html('<i>Ошибка отправки смс</i>').removeClass('success').addClass('error');

            clearTimeout(timer);
            timer = setTimeout(function(){
                $alert.removeClass('error success');
            }, alertCloseTime);

            if ($('html').is('.safari')) {
                return false;
            }

            $el.trigger('focus');
            $el.velocity('stop').velocity('callout.shake', {
                duration: 1000,
                delay: 0,
                stagger: 0,
                mobileHA: true,
                begin: function(){
                },
                complete: function(){

                }
            });
        },
        'email_exist': function(type, text, parameters){
            console.log('%ctrace: callback.default.phone_not_valid', 'color: #ccc');

            var $form = parameters.$form;
            var $alert = $form.find('.js__feedback-alert');
            var $el = $form.find('[name="telormail"]');

            $alert.html('<i>Указанная почта уже используется</i>').removeClass('success').addClass('error');

            clearTimeout(timer);
            timer = setTimeout(function(){
                $alert.removeClass('error success');
            }, alertCloseTime);

            if ($('html').is('.safari')) {
                return false;
            }

            $el.trigger('focus');
            $el.velocity('stop').velocity('callout.shake', {
                duration: 1000,
                delay: 0,
                stagger: 0,
                mobileHA: true,
                begin: function(){
                },
                complete: function(){

                }
            });
        },
        'phone_exist': function(type, text, parameters){
            console.log('%ctrace: callback.default.phone_not_valid', 'color: #ccc');

            var $form = parameters.$form;
            var $alert = $form.find('.js__feedback-alert');
            var $el = $form.find('[name="telormail"]');

            $alert.html('<i>Указанный телефон уже используется</i>').removeClass('success').addClass('error');

            clearTimeout(timer);
            timer = setTimeout(function(){
                $alert.removeClass('error success');
            }, alertCloseTime);

            if ($('html').is('.safari')) {
                return false;
            }

            $el.trigger('focus');
            $el.velocity('stop').velocity('callout.shake', {
                duration: 1000,
                delay: 0,
                stagger: 0,
                mobileHA: true,
                begin: function(){
                },
                complete: function(){

                }
            });
        },
        'add_coupon_true': function(type, text, parameters){
            console.log('%ctrace: callback.default.success', 'color: #ccc');

            var $form = parameters.$form;
            var $alert = $form.find('.js__feedback-alert');

            $form[0].reset();
            $alert.html('<i>Ваш купон успешно отправлен</i>').removeClass('error').addClass('success');

            clearTimeout(timer);
            timer = setTimeout(function(){
                $alert.removeClass('error success');
            }, alertCloseTime);

            //registration-success

            window.yaCounter28847745.reachGoal('registration-success');

            if ($('html').is('.safari')) {
                return false;
            }

            $alert.velocity('stop').velocity('callout.bounce', {
                duration: 1000,
                delay: 0,
                stagger: 0,
                mobileHA: true,
                begin: function(){
                },
                complete: function(){

                }
            });
        }
    };

    callback['add_feedback'] = {
        'add_feedback_true': function (type, text, parameters) {
            console.log('%ctrace: callback.default.success', 'color: #ccc');

            var $form = parameters.$form;
            var $alert = $form.find('.js__feedback-alert');

            $form[0].reset();
            $alert.html('Ваше сообщение успешно отправлено').removeClass('error').addClass('success');

            if ($('html').is('.safari')) {
                return false;
            }

            $alert.velocity('stop').velocity('callout.bounce', {
                duration: 1000,
                delay: 0,
                stagger: 0,
                mobileHA: true,
                begin: function(){
                },
                complete: function(){

                }
            });
        }
    };

    return callback;
});

